export class AttributeExcelImportModel {
    importacionId: number;
    primeraFila?: number;
    columnaClave?: number;
    eliminarExisitingAttributos?: boolean;
    camposImportacion: any;   
    excelfile: any;
}
